import { useCodeValidation } from '@form';
import * as yup from 'yup';

export const useValidation = () => {
  const codeValidation = useCodeValidation();

  return yup.object().shape(codeValidation);
};
